import React, { useEffect, useState } from 'react'
import { Button, Card, Grid, makeStyles, Typography, Container, List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, IconButton } from '@material-ui/core'
import { finishSpinner, startSpinner } from '../../actions/ui/spinner';
import { useHistory, useParams } from 'react-router';
import { handleErrorApi } from '../../helpers/randoms';
import { startAlerta } from '../../actions/ui/alertas';
import { useDispatch } from 'react-redux';
import { TIPO_NOTIFICACIONES } from '../../utils/constants';
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import AvisoPrestacionService from '../../services/AvisoPrestacionService';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import LoadingBeforeViewData from '../compartidos/LoadingBeforeViewData';
const useStyles = makeStyles((theme) => ({

    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    container: {
        marginLeft: "auto",
        marginRight: "auto",
        padding: "1rem",
        display: "block",
        borderRadius: 15
    },
    img: {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "1rem",
        width: "50%"
    },
    title: {
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "0.75rem",
        fontSize: "0.70rem",
        display: "block"
    }
}));

const getData = (celular, email) => ([
    {
        idTipoNotificacion: TIPO_NOTIFICACIONES.APP,
        descripcion: "App Mi Ospedyc",
        textoSecundario: "Se le notificará por este medio",
        icon: NotificationsNoneOutlinedIcon
    },
    {
        idTipoNotificacion: TIPO_NOTIFICACIONES.EMAIL,
        descripcion: "Correo electrónico",
        textoSecundario: email !== null && email !== "" && `Al correo electrónico ${email.slice(0, 3)}*****@${email.split('@')[1]}`,
        icon: EmailOutlinedIcon,
        disabled: email === ""
    },
    {
        idTipoNotificacion: TIPO_NOTIFICACIONES.SMS,
        descripcion: "SMS",
        textoSecundario: celular !== null && celular !== "" && `Al celular terminado en ${celular.slice(-4)}`,
        icon: ChatBubbleOutlineOutlinedIcon,
        disabled: celular === ""
    }
])

const NotificacionTurnoPrestadorExterno = () => {
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()

    const [idTipoNotificacion, setIdTipoNotificacion] = useState(null)
    const [codigoVerificacion, setCodigoVerificacion] = useState("")
    const [data, setData] = useState(null)

    const { idRegistroAtencion } = useParams();

    const handleEnviarNotificacion = async () => {
        try {
            dispatch(startSpinner())
            const result = await AvisoPrestacionService.enviarNotificacion(idRegistroAtencion, {
                idTipoNotificacion
            })
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                startAlerta("Notificación enviada correctamente", "success")
            } else {
                throw body
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al enviar la notificacion", "Ha ocurrido un error")
        }
    }

    const handleVerificar = async (e) => {
        e.preventDefault()
        try {
            dispatch(startSpinner())
            const result = await AvisoPrestacionService.verificarCodigo(idRegistroAtencion, { codigo: codigoVerificacion })
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                if (body.verificado !== null) {
                    if (body.verificado) {
                        history.push(`/afiliado/credenciales/informacion-afiliado/${body.idAfiliado}`)
                        dispatch(startAlerta("Turno Validado Exitosamente", "success"))
                    } else {
                        history.push(`/afiliado/credenciales/informacion-afiliado/${body.idAfiliado}`)
                        dispatch(startAlerta("Turno No Validado", "error"))
                    }
                } else {
                    if (body.cantCodigoErroneo === 5) {
                        history.push(`/afiliado/credenciales/informacion-afiliado/${body.idAfiliado}`)
                        dispatch(startAlerta("Ha alcanzado el maximo de intentos. Reingrese su CUIT", "error"))
                    } else {
                        dispatch(startAlerta("El código ingresado no es correcto", "error"))
                    }
                }
            } else {
                throw body
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al enviar la notificacion", "Ha ocurrido un error")
        }
    }

    const handleDataRegistroAtencion = async () => {
        try {
            const result = await AvisoPrestacionService.getData(idRegistroAtencion)
            const body = await result.json()
            if (result.ok) {
                setData(body)
            } else {
                throw body
            }
        } catch (error) {
            handleErrorApi(dispatch, error, "Error al OBTENER LA DATA", "Ha ocurrido un error")
        }
    }

    const handleGetVerificado = async () => {
        try {
            dispatch(startSpinner())
            const result = await AvisoPrestacionService.getData(idRegistroAtencion)
            const body = await result.json()
            if (result.ok) {
                if (body.verificado !== null) {
                    if (body.verificado) {
                        history.push(`/afiliado/credenciales/informacion-afiliado/${body.idAfiliado}`)
                        dispatch(startAlerta("Turno Validado Exitosamente", "success"))
                    } else {
                        history.push(`/afiliado/credenciales/informacion-afiliado/${body.idAfiliado}`)
                        dispatch(startAlerta("Turno Rechazado Por El Beneficiario/a", "error"))
                    }
                } else {
                    dispatch(startAlerta("Turno Aun No Validado/Rechazado Por El Beneficiario/a", "error"))
                }
                dispatch(finishSpinner())

            } else {
                throw body
            }
        } catch (error) {
            dispatch(finishSpinner())

            handleErrorApi(dispatch, error, "Error al OBTENER LA DATA", "Ha ocurrido un error")
        }
    }

    useEffect(() => {
        if (idTipoNotificacion !== null) {
            handleEnviarNotificacion()
        }
        // eslint-disable-next-line
    }, [idTipoNotificacion])

    useEffect(() => {
        handleDataRegistroAtencion()
        // eslint-disable-next-line
    }, [])

    if (data === null) {
        return <LoadingBeforeViewData />
    }
    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Grid container >
                    <Grid item xs={12} md={6} className={classes.container} elevation={6} component={Card} variant="outlined">
                        <Typography variant="h5" align="center">Verificación de beneficiario/a</Typography>
                        {
                            idTipoNotificacion === null
                                ?
                                <>
                                    <Typography style={{ fontSize: "0.85rem", marginTop: "0.5rem" }} align="center">Hola <span style={{ fontWeight: "bold" }}>{data.nombrePrestador}</span></Typography>
                                    <Typography style={{ fontSize: "0.85rem", marginTop: "0.5rem" }} align="center">Elige como enviar el código de verificación</Typography>
                                    <List>
                                        {
                                            getData(data.celularAfiliado, data.emailAfiliado).map((opcion, index) => {
                                                return (
                                                    <ListItem index={index}>
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <opcion.icon />
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={opcion.descripcion}
                                                            secondary={opcion.textoSecundario}
                                                        />
                                                        {
                                                            !opcion.disabled &&
                                                            <ListItemSecondaryAction onClick={() => setIdTipoNotificacion(opcion.idTipoNotificacion)}>
                                                                <IconButton edge="end" aria-label="delete">
                                                                    <ArrowForwardIosOutlinedIcon />
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        }
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </>
                                :
                                <>
                                    <Typography style={{ fontSize: "0.85rem", marginTop: "1rem", marginBottom: "1rem" }} align="center">
                                        {
                                            idTipoNotificacion === TIPO_NOTIFICACIONES.APP
                                                ?
                                                "Una vez el beneficiario/a reciba la notificación y la acepte, podra verificar y terminar la operación haciendo click en el botón de abajo"
                                                :
                                                "A continuación, ingrese el código de verificación que le fue enviado al beneficiario/a"
                                        }

                                    </Typography>

                                    {
                                        idTipoNotificacion === TIPO_NOTIFICACIONES.APP
                                            ?
                                            <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
                                                <Button variant="contained" color="primary" onClick={handleGetVerificado} >Verificar</Button>
                                                <div style={{ cursor: "pointer", marginTop: "0.5rem" }}>
                                                    <Typography onClick={() => setIdTipoNotificacion(null)} color="primary" variant="caption" >Probar otro método de verificación</Typography>
                                                </div>
                                            </div>
                                            :

                                            <ValidatorForm onSubmit={handleVerificar}>

                                                <TextValidator
                                                    margin="normal"
                                                    fullWidth
                                                    value={codigoVerificacion}
                                                    type="text"
                                                    label="Código de verificación"
                                                    onChange={(e) => setCodigoVerificacion(e.target.value)}
                                                    validators={['required', 'isNumber', 'minStringLength:6', 'maxStringLength:6']}
                                                    errorMessages={['El código es requerido', 'El codigo posee 6 números', 'El codigo posee 6 dígitos', 'El codigo posee 6 dígitos']}
                                                    variant="outlined"
                                                />
                                                <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
                                                    <Button variant="contained" color="primary" type="submit" >Verificar</Button>
                                                    <div style={{ cursor: "pointer", marginTop: "0.5rem" }}>
                                                        <Typography onClick={() => setIdTipoNotificacion(null)} color="primary" variant="caption" >Probar otro método de verificación</Typography>
                                                    </div>
                                                </div>

                                            </ValidatorForm>
                                    }

                                </>
                        }

                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default NotificacionTurnoPrestadorExterno
